import { render } from "./DropzoneReceipt.vue?vue&type=template&id=1f5ed805"
import script from "./DropzoneReceipt.vue?vue&type=script&lang=js"
export * from "./DropzoneReceipt.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__